/**
 * Publishes Shopify product_added_to_cart analytics events after AJAX cart adds.
 *
 * Shopify's native tracking listens to /cart/add form posts. Custom fetch() flows
 * need to emit this event manually so Admin analytics and web pixels receive them.
 */
(function() {
  'use strict';

  window.theme = window.theme || {};

  function getCurrencyCode(override) {
    if (override) return override;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return '';
  }

  function normalizeAddResponse(response) {
    if (!response || (response.status && response.status !== 200)) return [];

    if (Array.isArray(response.items)) return response.items;
    if (response.variant_id || response.product_id) return [response];

    return [];
  }

  function buildCartLine(item, currencyCode) {
    var lineCents = item.final_line_price != null ? item.final_line_price : (item.line_price || 0);
    var unitCents = item.final_price != null ? item.final_price : (item.price || 0);
    var productUrl = item.url ? item.url.split('?')[0] : null;
    var imageSrc = null;

    if (item.image) {
      imageSrc = item.image;
    } else if (item.featured_image) {
      imageSrc = typeof item.featured_image === 'string'
        ? item.featured_image
        : item.featured_image.url;
    }

    return {
      cost: {
        totalAmount: {
          amount: lineCents / 100,
          currencyCode: currencyCode
        }
      },
      merchandise: {
        id: String(item.variant_id),
        title: item.variant_title || null,
        untranslatedTitle: item.variant_title || null,
        sku: item.sku || '',
        price: {
          amount: unitCents / 100,
          currencyCode: currencyCode
        },
        product: {
          id: String(item.product_id),
          title: item.product_title || item.title || '',
          vendor: item.vendor || '',
          type: item.product_type || '',
          url: productUrl,
          untranslatedTitle: item.product_title || item.title || ''
        },
        image: imageSrc ? { src: imageSrc } : null
      },
      quantity: item.quantity || 1
    };
  }

  window.theme.publishAddToCartAnalytics = function(response, options) {
    options = options || {};

    if (options.skip) return;

    var publish = window.Shopify
      && window.Shopify.analytics
      && window.Shopify.analytics.publish;

    if (typeof publish !== 'function') return;

    var items = normalizeAddResponse(response);
    if (!items.length) return;

    var currencyCode = getCurrencyCode(options.currencyCode);

    items.forEach(function(item) {
      try {
        publish('product_added_to_cart', buildCartLine(item, currencyCode));
      } catch (err) {
        if (window.Shopify && window.Shopify.designMode) {
          console.warn('[Cart analytics]', err);
        }
      }
    });
  };
})();
